export const NAME = 'association';

export const REQUEST_ASSOCIATION = 'REQUEST_ASSOCIATION';
export const SUCCESS_ASSOCIATION = 'SUCCESS_ASSOCIATION';
export const FAILURE_ASSOCIATION = 'FAILURE_ASSOCIATION';



// WEBPACK FOOTER //
// ./src/services/association/constants.js